import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_DOCUMENT } from "../../constants/modules"

import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocumentTypes(params = {}) {
    const url = "document_types/"
    const queryParameters = useExtendWithSubnetworks(params, API_MODULE_DOCUMENT)
    const queryKey = documentQueryKeys.types(queryParameters)

    return useDocumentQuery(
        url,
        queryKey,
        queryParameters,
        {
            autoRefetch: true,
        },
    )
}